package com.iptvplayer.shared.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed class IptvSource {
    abstract val id: String
    abstract val name: String

    @Serializable
    @SerialName("m3u")
    data class M3USource(
        override val id: String,
        override val name: String,
        val url: String
    ) : IptvSource()

    @Serializable
    @SerialName("xtream")
    data class XtreamSource(
        override val id: String,
        override val name: String,
        val serverUrl: String,
        val username: String,
        val password: String
    ) : IptvSource()
}
